import { useParams } from "react-router";
import MainStages from "./components/MainWrapper/MainStages";
import { WplywContext } from "../../context/wplywContext";
import { useContext } from "react";
import { Spin, Alert } from "antd";

const Wplyw = () => {
    const { wplywid } = useParams();
    const { wplyw } = useContext(WplywContext);

    const isLoading = wplyw.wplyw_loading;
    const hasData = wplyw?.wplyw_data?.data; // Check if data exists

    return (
        <>
            {isLoading ? (
                <Spin spinning={true}>
                    <div style={{ height: "100vh" }}></div>
                </Spin>
            ) : hasData ? (
                <MainStages />
            ) : (
                <Alert
                    message="Brak danych"
                    description="Nie udało się załadować danych wpływu. Sprawdź ID lub spróbuj ponownie."
                    type="error"
                    showIcon
                />
            )}
        </>
    );
};

export default Wplyw;
